export default {
  searchHeader: 'Dashboard',
  searchPlaceholder: 'Search samples...'
};
